/**
 * Created by daniel on 27/04/17.
 */

import React, {Component} from 'react';
import './DropZoneFrame.css'

class DropZoneFrame extends Component {
  render() {
    let style = {
      position: "absolute",
      ...this.props.coords,
      zIndex: 10,
    };
    
    return (
      <div
        className="editor-dropzone-frame"
        style={style}/>
    );
  }
}

export default DropZoneFrame;


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/DropZoneFrame.js